import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StockPromotionService {
  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getAllStockPromotion(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/stock-promotion`, { params: filters }));
  }

  cancelStockProduct(id: string) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/stock-promotion/deleted/${id}`, {}));
  }

  updateStockProduct(id: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/stock-promotion/${id}`, body));
  }

}
